import { Col } from 'reactstrap';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Email = ({ practiceEmail = '--' }) => {
    return (
        <Col
            lg={6}
            md={12}
            className='hide-overflow py-3 d-flex px-3 py-2'
            title="Contact Email">
            <FontAwesomeIcon
                className="text-light op-6"
                icon={faEnvelope}
                size="lg"
            />
            &emsp;
            <div>{practiceEmail ?? '--'}</div>
        </Col>
    );
};

export default Email;
